exports.isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

exports.validatePhone = val => {
  const regex = RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
  if (regex.test(val)) {
    return true;
  } else {
    return false;
  }
}

exports.validateEmail = val => {
  const regex = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  if (regex.test(val)) {
    return true;
  } else {
    return false;
  }
};
